import React from 'react';

import { darkPurple, mediumGray } from 'utils/color-styles';

export const ProgressBar = ({
  currentStep,
  stepCount,
  actions,
}: {
  currentStep: number;
  stepCount: number;
  actions?: JSX.Element;
}): JSX.Element => (
  <div style={{ flexGrow: 1 }}>
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ marginRight: 8 }}>
          <span style={{ color: darkPurple }}>{currentStep}</span> / {stepCount}
        </div>
        <div style={{ position: 'relative', backgroundColor: mediumGray, width: 100, height: 2 }}>
          <div
            style={{
              position: 'absolute',
              backgroundColor: darkPurple,
              width: `${(currentStep / stepCount) * 100}%`,
              height: '100%',
            }}
          />
        </div>
      </div>
      {actions}
    </div>
  </div>
);
